import Vue from 'vue';

import SurveyApi from '../../../api/SurveyApi';
import Segment from '../../../Segment';

const QUESTION_TYPES = {
  TEXT: 'text',
};

const state = {
  surveyCompleted: false,
  questionTypes: QUESTION_TYPES,
  question: {
    name: 'ChurnQuestion',
    text: 'נשמח לשמוע בכמה מילים למה החלטת לעזוב את השירות',
    type: QUESTION_TYPES.TEXT,
    required: true,
    answer: null,
  },
};

const getters = {
  isEmptyAnswer: state => !state.question.answer,
};

const actions = {
  setAnswer({ commit }, { questionName, answer }) {
    commit('setAnswer', { questionName, answer });
  },
  async saveAnswers({ commit, state }) {
    commit('setSurveyCompleted', true);
    const churnCustomerDetails = JSON.parse(localStorage.getItem('riseup.churnSurvey'));
    if (churnCustomerDetails && churnCustomerDetails.id) {
      await SurveyApi.saveChurnSurveyAnswers({
        customerId: churnCustomerDetails.id,
        subscriptionState: churnCustomerDetails.state,
        answers: [_extractAnswer(state.question)],
      });
    } else {
      Segment.trackUserInteraction('ChurnSurveyHasNoCustomerId');
    }
  },
};

const mutations = {
  setAnswer(state, { answer }) {
    Vue.set(state.question, 'answer', answer);
  },
  setSurveyCompleted(state, completed) {
    state.surveyCompleted = completed;
  },
};

function _extractAnswer(question) {
  return {
    name: question.name,
    answer: `${question.answer}`,
  };
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
